import { API } from "../apis/APIsConfig";
import Constants from "../utils/constants";

export function getBeneficios() {
  return API.get(Constants.APIURLS.SOLICITUDESBYFILTROS);
}

export function getSolicitudes() {
  return API.get(Constants.APIURLS.SOLICITUDESZENDESK);
}

export function getReclamos() {
  return API.get(Constants.APIURLS.RECLAMOSZENDESK);
}

export function getSolicitudById(id) {
  return API.get(Constants.APIURLS.SOLICITUDBYID + id, {});
}

export function getReclamoById(id) {
  return API.get(Constants.APIURLS.RECLAMOBYID + id, {});
}

// solo usar los que tiene 'S'
export function getTiposSolicitud() {
  return API.get(Constants.APIURLS.TIPOSSOLICITUD);
}

export function getMotivosReclamos() {
  return API.get(Constants.APIURLS.MOTIVOSRECLAMOS);
}

export function getMediosEnvio() {
  return API.get(Constants.APIURLS.OBTENERMEDIOS);
}

export function saveSolicitud(solicitud: any) {
  return API.post(Constants.APIURLS.GUARDARSOLICITUD, solicitud);
}

export function saveReclamo(reclamo: any) {
  return API.post(Constants.APIURLS.GUARDARRECLAMO, reclamo);
  //return API.post("http://localhost:3795/APIGateway/api/Reclamos/Guardar", reclamo);
}
